/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  TextField,
  Popover,
  useMediaQuery,
  Button,
} from "@material-ui/core";
import moment from "moment-timezone";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SingleSelect from "../../../../components/SelectField/SingleSelect";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import TableToolbar from "../../../../components/Table/TableToolbar";
import { getTimesheetListReportOld } from "../../../../services/apiservices/timesheets";
import { getUserListBasedOnIds } from "../../../../services/apiservices/users";
import Link from "@mui/material/Link";
import styles from "../../Report.module.scss";
import "../../../home/dashboard.module.scss";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import * as Excel from "exceljs";
import { useNavigate } from "react-router-dom";
import ResponsiveTable from "../../../../components/ResponsiveCardComponent/ReportsComponent/EmployeeReports/ResponsiveTimeSheet";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import ActionRender from "../../ActionRender";
import AuthContext from "../../../../hooks/authContext";
import { getSettings } from "../../../../services/apiservices/settings";

function formatHoursMinutes(num) {
  return num.toFixed(2);
  // const n = new Date(0, 0);
  // n.setMinutes(+Math.round(num * 60));

  // let hours = n.getHours()
  // const minutes = n.getMinutes();

  // if (num) {
  //   const hrArr = num.toString().split(".");
  //   hours = hrArr[0];
  // }
  // return (hours + ":" + minutes.toString().padStart(2, '0'));
}

const CustomTooltip = ({ title, listData }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      {listData ? (
        <>
          <div onClick={handleClick}>{formatHoursMinutes(title)}</div>
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <div className="tooltip-heading2 p-5 ">
              <div className="tooltip-container2">
                {listData.map((item, i) => {
                  return (
                    <>
                      <div key={item.shiftName} className="pt-5 dark:text-white">
                        <b>Shift : </b> {item.shiftName}
                        <div>
                          <div>
                            <b>In : </b>
                            <Link
                              className={`${styles.timeZone2} dark:text-white`}
                              target="_blank"
                              rel="noopener"
                              href={`https://maps.google.com/?q=${item.location?.lat},${item.location?.lng}`}
                            >
                              {item.In}
                            </Link>
                          </div>
                          <div>
                            <b>Out : </b>
                            <Link
                              className={`${styles.timeZone2} dark:text-white`}
                              target="_blank"
                              rel="noopener"
                              href={`https://maps.google.com/?q=${item.shiftend_location?.lat},${item.shiftend_location?.lng}`}
                            >
                              {item.Out}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </Popover>
        </>
      ) : (
        <div>{formatHoursMinutes(title)}</div>
      )}
    </div>
  );
};

function TimeSheet(props) {
  const [clientsListCSV, setClientListCSV] = useState([]);
  const navigate = useNavigate();
  const [payPeriod, setPayPeriod] = useState("None");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [payperiodStartDate, setPaypeiodStartDate] = useState(null);
  const [payperiodEndDate, setPayperiodEndDate] = useState(null);
  const [data, setData] = useState();
  const [empName, setEmpName] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [empData, setEmpData] = useState([]);
  const [empFilterData, setEmpFilterData] = useState([]);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [detailedView, setDetailedView] = useState(null);
  const auth = useContext(AuthContext);
  const { setReportData } = auth || {};
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

   const fetchSettings = async () => {
     const companyId =
     auth?.userProfile?.role === "companyUser"
     ? auth?.userProfile?.id
     : auth?.userProfile?.companyId;
     
     getSettings("client_settings", companyId, (res) => {
        if (res?.data) {
          const filteredData = res.data.filter(
            (item) => !item.deleted
          );
  
          if (filteredData?.length > 0) {
            const [firstItem] = filteredData;
            setData(filteredData);
            setPaypeiodStartDate(
              firstItem?.startDate
                ? moment(firstItem?.startDate, "YYYY-MM-DD")
                : null
            );
            setPayperiodEndDate(
              firstItem?.endDate ? moment(firstItem?.endDate, "YYYY-MM-DD") : null
            );
          } else {
            setData();
            setPaypeiodStartDate();
            setPayperiodEndDate();
          }
        } else {
          setData();
          setPaypeiodStartDate();
          setPayperiodEndDate();
        }
      });
    };
  
    useEffect(() => {
      fetchSettings();
    }, []);

  useEffect(() => {
    let paramStartDate = "";
    let paramEndDate = "";
    if (payPeriod !== "None") {
      // paramStartDate = moment().subtract(payPeriod, "weeks").startOf("isoWeek");
      // paramEndDate = moment().subtract(payPeriod, "weeks").endOf("isoWeek");
      const [start, end] = payPeriod?.split("|");
      paramStartDate = moment(start);
      paramEndDate = moment(end);
    } else {
      paramStartDate = startDate;
      paramEndDate = endDate;
    }
    getReportListData(paramStartDate, paramEndDate);
  }, [payPeriod, startDate, endDate]);

  // const getPayPeriodDropDownOptions = () => {
  //   const weeksDate = [];
  //   weeksDate.push({ label: "None", value: "None" });
  //   for (let i = 1; i <= 4; i++) {
  //     const startStr = moment()
  //       .subtract(i, "weeks")
  //       .startOf("isoWeek")
  //       .format("ddd MMM DD, YYYY");
  //     const endStr = moment()
  //       .subtract(i, "weeks")
  //       .endOf("isoWeek")
  //       .format("ddd MMM DD, YYYY");
  //     weeksDate.push({ label: `${startStr} - ${endStr}`, value: i });
  //   }
  //   return weeksDate;
  // };

  const getPayPeriodDropDownOptions = () => {
    if (!payperiodStartDate || !payperiodEndDate) return [];

    const payPeriods = [];
    let currentStart = moment(payperiodStartDate);
    const finalEnd = moment(payperiodEndDate);

    while (currentStart.isBefore(finalEnd)) {
      const currentEnd = moment.min(moment(currentStart).endOf("isoWeek"), finalEnd);

      payPeriods.push({
        label: `${currentStart.format("ddd MMM DD, YYYY")} - ${currentEnd.format(
          "ddd MMM DD, YYYY"
        )}`,
        value: `${currentStart.format("YYYY-MM-DD")}|${currentEnd.format(
          "YYYY-MM-DD"
        )}`,
      });

      currentStart = currentEnd.add(1, "day").startOf("day");
    }

    return payPeriods;
  };

  const onChangePayPeriod = (e) => {
    const selectedValue = e.target.value;
    setPayPeriod(selectedValue);

    if (selectedValue !== "None") {
      const [start, end] = selectedValue?.split("|");
      setStartDate(moment(start));
      setEndDate(moment(end));
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };


  // const onChangePayPeriod = (e) => {
  //   const selectedPayPeriod = e.target.value;
  //   setPayPeriod(selectedPayPeriod);

  //   if (selectedPayPeriod !== "None") {
  //     const newStartDate = moment()
  //       .subtract(selectedPayPeriod, "weeks")
  //       .startOf("isoWeek");
  //     const newEndDate = moment()
  //       .subtract(selectedPayPeriod, "weeks")
  //       .endOf("isoWeek");
  //     setStartDate(newStartDate);
  //     setEndDate(newEndDate);
  //   } else {
  //     setStartDate(null);
  //     setEndDate(null);
  //   }
  // };

  const handleEmpNameChange = (e) => {
    const str = e.target.value;
    setEmpName(str);

    const empfinalData = empData.filter((itme) =>
      itme.name.toUpperCase().includes(str?.toUpperCase())
    );
    setEmpFilterData(empfinalData);
  };

  const getColumns = () => {
    const columns = [];
    columns.push({
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Employee Name",
      isSortable: true,
    });

    let paramStartDate = "";
    let paramEndDate = "";
    // if (payPeriod !== "None") {
    //   paramStartDate = moment().subtract(payPeriod, "weeks").startOf("isoWeek");
    //   paramEndDate = moment().subtract(payPeriod, "weeks").endOf("isoWeek");

    //   for (
    //     let m = moment(paramStartDate);
    //     m.isBefore(paramEndDate);
    //     m.add(1, "days")
    //   ) {
    //     columns.push({
    //       id: m.format("YYYY-MM-DD"),
    //       numeric: false,
    //       disablePadding: false,
    //       label:
    //         isMobile || isLandscape
    //           ? m.format("MMM DD YYYY")
    //           : m.format("MM/DD (ddd)"),
    //       isSortable: true,
    //       clickable: true,
    //     });
    //   }
    // } 
    if (payPeriod !== "None") {
       const [start, end] = payPeriod?.split("|");
        paramStartDate = moment(start);
        paramEndDate = moment(end);

       for (let m = moment(paramStartDate); m.isSameOrBefore(paramEndDate); m.add(1, "days")) {
      columns.push({
        id: m.format("YYYY-MM-DD"),
        numeric: false,
        disablePadding: false,
        label:
          isMobile || isLandscape
            ? m.format("MMM DD YYYY")
            : m.format("MM/DD (ddd)"),
        isSortable: true,
        clickable: true,
      });
    }
    } else if (startDate !== "" && endDate !== "") {
      paramStartDate = startDate;
      paramEndDate = endDate;
      for (
        let m = moment(startDate);
        m.isSameOrBefore(endDate);
        m.add(1, "days")
      ) {
        columns.push({
          id: m.format("YYYY-MM-DD"),
          numeric: false,
          disablePadding: false,
          label:
            isMobile || isLandscape
              ? m.format("MMM DD YYYY")
              : m.format("MM/DD (ddd)"),
          isSortable: true,
          clickable: true,
        });
      }
    }

    columns.push({
      id: "total",
      numeric: false,
      disablePadding: false,
      label: "Total",
      isSortable: true,
    });

    columns.push({
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      isSortable: false,
    });
    if (isMobile || isLandscape) {
      return columns.filter((col) => col.id !== "action");
    }
    return columns;
  };

  const getDatatoDownload = (rcellItem, columns, date) => {
    if (date !== undefined) {
      const clientCSV = rcellItem.map((item) => {
        const baseRow = [`${item?.firstName} ${item.lastName}`];

        let cellValue;
        columns.forEach((col) => {
          if (col.id === date) {
            cellValue = item[col.id];
            baseRow.push(cellValue !== undefined ? cellValue : "-");
          }
        });
        item.total = cellValue;
        baseRow.push(item.total);

        const popupDataValue =
          item.popupData && item.popupData[date] ? item.popupData[date] : null;
        const popupDataRow = popupDataValue
          ? popupDataValue
              .map(
                (data) =>
                  `Shift:${data.shiftName}\nIn:${data.In}\nOut:${data.Out}`
              )
              .join("\n\n")
          : "-";

        return popupDataRow ? [baseRow, ["", popupDataRow]] : [baseRow];
      });

      return clientCSV.flat();
    } else {
      if (Array.isArray(rcellItem)) {
        const newRecords = [];

        rcellItem.forEach((obj) => {
          if (!newRecords.some((item) => item.name === obj.name)) {
            newRecords.push(obj);
          }
        });

        const clientCSV = newRecords.flatMap((item) => {
          const baseRow = [`${item?.firstName} ${item.lastName}`];

          columns.forEach((col) => {
            if (
              col.id !== "name" &&
              col.id !== "total" &&
              col.id !== "action"
            ) {
              const cellValue = item[col.id];
              baseRow.push(cellValue !== undefined ? cellValue : "-");
            }
          });

          baseRow.push(item?.total !== undefined ? item.total : "-");

          const dataRows = columns.map((col) => {
            const date = col.id;
            if (item.popupData && item.popupData[date]) {
              const popupForDate = item.popupData[date];
              if (popupForDate.length > 0) {
                const shiftDetails = popupForDate
                  .map(
                    (data) =>
                      `Shift:${data.shiftName}\nIn:${data.In}\nOut:${data.Out}`
                  )
                  .join("\n\n");
                return shiftDetails;
              }
              return "-";
            }
            return "-";
          });

          return [baseRow, dataRows];
        });
        return clientCSV;
      } else {
        const clientCSV = empData
          .filter((item) => item.userId === rcellItem.userId)
          .flatMap((item) => {
            const baseRow = [`${item?.firstName} ${item.lastName}`];

            columns.forEach((col) => {
              if (
                col.id !== "name" &&
                col.id !== "total" &&
                col.id !== "action"
              ) {
                const cellValue = item[col.id];
                baseRow.push(cellValue !== undefined ? cellValue : "-");
              }
            });

            baseRow.push(item?.total !== undefined ? item.total : "-");

            const dataRows = columns.map((col) => {
              const date = col.id;
              if (rcellItem.popupData[date]) {
                const popupForDate = rcellItem.popupData[date];
                if (popupForDate.length > 0) {
                  const shiftDetails = popupForDate
                    .map(
                      (data) =>
                        `Shift:${data.shiftName}\nIn:${data.In}\nOut:${data.Out}`
                    )
                    .join("\n\n");
                  return shiftDetails;
                }
                return "-";
              }
              return "-";
            });

            return [baseRow, dataRows];
          });
        return clientCSV;
      }
    }
  };

  const getDatatoFullDownload = (items, columns) => {
    if (!Array.isArray(items)) {
      items = [items];
    }

    const dataRows = items.flatMap((item) => {
      const baseRow = [`${item?.firstName} ${item?.lastName}`];

      columns.forEach((col) => {
        if (col.id !== "name" && col.id !== "action") {
          const cellValue = item[col.id];
          baseRow.push(cellValue !== undefined ? cellValue : "-");
        }
      });

      const datewiseData = columns.map((col) => {
        const date = col.id;
        if (item.popupData && item.popupData[date]) {
          const popupForDate = item.popupData[date];
          const shiftDetails = popupForDate
            .map(
              (data) =>
                `Shift:${data.shiftName}\n In:${data.In}\n Out:${data.Out}`
            )
            .join("\n\n");
          return shiftDetails;
        }
        return "-";
      });

      return [baseRow, datewiseData];
    });

    return dataRows;
  };

  const selectedPayPeriodOption = getPayPeriodDropDownOptions().find(
    (option) => option.value === payPeriod
  );

  const downloadForExcel = async (rcellItem, date, emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet("TimeSheet Report");

    const columns = getColumns(payPeriod, startDate, endDate);
    const clientCSV = getDatatoDownload(rcellItem, columns, date);
    const csvHeaders = date
      ? columns
          .filter(
            (col) => col.id === "name" || col.id === date || col.id === "total"
          )
          .map((col) => col.label)
      : columns.filter((col) => col.id !== "action").map((col) => col.label);
    const dates =
      payPeriod !== "None"
        ? `${selectedPayPeriodOption.label}`
        : isMobile || isLandscape
        ? `${moment(date).format("YYYY-MM-DD")}`
        : `${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format(
            "YYYY-MM-DD"
          )}`;

    let fileName;
    if (Array.isArray(rcellItem)) {
      if (rcellItem.length === 1) {
        fileName = `TimeSheetReport_${rcellItem[0]?.firstName ?? ""} ${
          rcellItem[0]?.lastName ?? ""
        }_${dates}`;
      } else {
        fileName = `TimeSheetReport_All_${dates}`;
      }
    } else {
      fileName = `TimeSheetReport_${rcellItem?.firstName ?? ""} ${
        rcellItem?.lastName ?? ""
      }_${dates}`;
    }
    let name = true;
    let fullpage = true;
    return await downloadExcel(
      clientCSV,
      csvHeaders,
      wb,
      ws,
      fileName,
      emailSend,
      name,
      fullpage
    );
  };

  const downloadForPDF = async (rcellItem, date, emailSend) => {
    const columns = getColumns(payPeriod, startDate, endDate);
    const clientCSV = getDatatoDownload(rcellItem, columns, date);

    const csvHeaders = date
      ? columns
          .filter(
            (col) => col.id === "name" || col.id === date || col.id === "total"
          )
          .map((col) => col.label)
      : columns.filter((col) => col.id !== "action").map((col) => col.label);

    const dates =
      payPeriod !== "None"
        ? `${selectedPayPeriodOption.label}`
        : isMobile || isLandscape
        ? `${moment(date).format("YYYY-MM-DD")}`
        : `${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format(
            "YYYY-MM-DD"
          )}`;

    let fileName;
    if (Array.isArray(rcellItem)) {
      if (rcellItem.length === 1) {
        fileName = `TimeSheetReport_${rcellItem[0]?.firstName ?? ""} ${
          rcellItem[0]?.lastName ?? ""
        }_${dates}`;
      } else {
        fileName = `TimeSheetReport_All_${dates}`;
      }
    } else {
      fileName = `TimeSheetReport_${rcellItem?.firstName ?? ""} ${
        rcellItem?.lastName ?? ""
      }_${dates}`;
    }
    let name = true;
    let fullpage = true;
    const logo = data?.[0]?.companyLogo;
    return await downloadPDF(
      logo,
      clientCSV,
      csvHeaders,
      fileName,
      emailSend,
      name,
      fullpage
    );
  };

  const setDownloadCSVData = (event, done, rcellItem, date) => {
    const columns = getColumns(payPeriod, startDate, endDate);
    let csvHeaders;

    if (date) {
      csvHeaders = columns
        .filter(
          (col) => col.id === "name" || col.id === date || col.id === "total"
        )
        .map((col) => col.label);
    } else {
      csvHeaders = columns
        .filter((col) => col.id !== "action")
        .map((col) => col.label);
    }
    const clientCSV = getDatatoDownload(rcellItem, columns, date);

    const reportName = "TimeSheet Report";
    const employeeName = Array.isArray(rcellItem)
      ? rcellItem.length === 1
        ? rcellItem[0].employeeName
        : "All"
      : `${rcellItem?.firstName ?? ""} ${rcellItem?.lastName ?? ""}`.trim();

    const reportPeriod =
      payPeriod !== "None"
        ? selectedPayPeriodOption.label
        : isMobile || isLandscape
        ? `${moment(date).format("YYYY-MM-DD")}`
        : `${moment(startDate).format("YYYY-MM-DD")} to ${moment(
            endDate
          ).format("YYYY-MM-DD")}`;

    // Create the report details rows
    const reportDetails = [
      [`Employee Name: ${employeeName}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV,
    ];

    // Set the CSV data
    setClientListCSV(reportDetails);
    done();
  };

  const downloadForFullPDF = async (emailSend) => {
    const columns = getColumns(payPeriod, startDate, endDate);
    const csvHeaders = columns
      .filter((col) => col.id !== "action")
      .map((col) => col.label);
    const clientCSV = getDatatoFullDownload(empData, columns);

    let empNamefordwonLoad =
      empData.length > 1
        ? "All"
        : `${empData[0]?.firstName}${empData[0]?.lastName}`;
    let fileName = `TimeSheetReport_${empNamefordwonLoad}_${
      payPeriod !== "None"
        ? selectedPayPeriodOption.label
        : `${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format(
            "YYYY-MM-DD"
          )}`
    }`;
    let name = true;
    let fullpage = true;
    const logo = data?.[0]?.companyLogo;
    return await downloadPDF(
      logo,
      clientCSV,
      csvHeaders,
      fileName,
      emailSend,
      name,
      fullpage
    );
  };

  const downloadForFullExcel = async (emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet("TimeSheet Report");

    const columns = getColumns(payPeriod, startDate, endDate);
    const csvHeaders = columns
      .filter((col) => col.id !== "action")
      .map((col) => col.label);
    const clientCSV = getDatatoFullDownload(empData, columns);

    let empNamefordwonLoad = empData
      ? `${empData?.firstName} ${empData.lastName}`
      : "All";
    const names =
      payPeriod !== "None"
        ? `${selectedPayPeriodOption.label}`
        : `${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format(
            "YYYY-MM-DD"
          )}`;
    let fileName = `TimeSheetReport_${empNamefordwonLoad}_${names}`;
    let name = true;
    let fullpage = true;
    return await downloadExcel(
      clientCSV,
      csvHeaders,
      wb,
      ws,
      fileName,
      emailSend,
      name,
      fullpage
    );
  };

  const handleEmailIconClick = async (rcellItem, date) => {
      const emailSend = true;
      let name;
    if (Array.isArray(rcellItem)) {
      if (rcellItem.length === 1) {
        name = `${rcellItem[0]?.firstName} ${rcellItem[0]?.lastName}`;
      } else {
        name = "All";
      }
    } else {
      name = `${rcellItem?.firstName} ${rcellItem?.lastName}`;
    }

    const Dates =
      payPeriod !== "None" && (isMobile || isLandscape)
        ? `${selectedPayPeriodOption.label}`
        : payPeriod === "None" && (isMobile || isLandscape)
        ? `${moment(date).format("YYYY-MM-DD")}`
        : `${startDate}`;
      const [excelBlob, pdfBlob] = await Promise.all([
        downloadForExcel(rcellItem, emailSend),
        downloadForPDF(rcellItem, emailSend)
      ]);
      // Convert the Excel blob to a base64-encoded string
      const reader = new FileReader();
      reader.readAsDataURL(excelBlob);
      reader.onloadend = function () {
        const base64Data = reader.result;
        setReportData((prev) => ({
          ...prev,
          FileName: "TimeSheet Report",
          ReportsName: "Employee Report",
          Name: name,
          Date: Dates,
          EndDate: endDate,
          pdf: pdfBlob,
          storedData: base64Data,
          fullData: "",
          fullExcelData: ""
        }));
        navigate("/emailreports");
      };
    };

    const handelEmailFullReport = async () => {
      const emailSend = true;

      let empNamefordwonLoad =
      empData.length > 1
        ? "All"
        : `${empData[0]?.firstName}${empData[0]?.lastName}`;

    const Dates =
      payPeriod !== "None"
        ? `${selectedPayPeriodOption.label}`
        : `${startDate}`;

      const [fullReport, fullExcelReport] = await Promise.all([
        downloadForFullPDF(emailSend),
        downloadForFullExcel(emailSend)
      ]);
      const reader = new FileReader();
      reader.readAsDataURL(fullExcelReport);
      reader.onloadend = function () {
        const base64Data = reader.result;
        setReportData((prev) => ({
        ...prev,
          FileName: "TimeSheet Report",
          ReportsName: "Employee Report",
          Name: empNamefordwonLoad,
          Date: Dates,
          EndDate: endDate,
          fullData: fullReport,
          fullExcelData: base64Data,
          pdf: "",
          storedData: ""
        }));
        navigate("/emailreports");
      }
    }

  const handlePdfClick = async (records, date, emailSend) => {
    await downloadForPDF(records, date, emailSend);
  };

  const handleExcelClick = async (records, date, emailSend) => {
    await downloadForExcel(records, date, emailSend);
  };

  const handleCSvClick = async (event, done, records, date) => {
    await setDownloadCSVData(event, done, records, date);
  };

  const handelEmailClicks = async (records, date) => {
    await handleEmailIconClick(records, date);
  };

  function formatTime(timestamp, timezone = "America/New_York") {
    const seconds = timestamp?.seconds;
    const milliseconds = seconds * 1000;
    return moment(milliseconds).tz(timezone).format("hh:mm A");
  }
  // Function to format time difference
  function formatTimeDifference(hours, minutes) {
    if (hours === 0 && minutes === 0) {
      return "0";
    } else {
      const absHours = Math.abs(hours);
      const absMinutes = parseInt(Math.abs(minutes * 100 / 60), 10);
      return `${absHours}.${absMinutes.toString().padStart(2, "0")}`;
    }
  }

  const mapWidhtUserList = async (userIds, timeSheetData) => {
    getUserListBasedOnIds(
      userIds,
      (result) => {
        const empResult = result?.filter((item)=> item.companyId === companyId);
        const finaleData = empResult?.map((resItem) => {
          const userTimeSheet = timeSheetData.filter(
            (itm) => itm.userId === resItem.id
          );

          let popupData = {};
          let dateArr = [];
          let allCheckInMiliseconds = [];
          let hours = 0;

          for (let i = 0; i < userTimeSheet?.length; i++) {
            // const checkInTime = formatTime(userTimeSheet[i]?.checkInDateTime, userTimeSheet[i]?.apoointmentDetails?.calendarTimezone);
            // const checkOutTime = formatTime(userTimeSheet[i]?.checkOutDateTime, userTimeSheet[i]?.apoointmentDetails?.calendarTimezone);
            let checkInTime = moment.unix(userTimeSheet[i]?.checkInDateTime?.seconds).tz(userTimeSheet[i]?.apoointmentDetails?.calendarTimezone);
            let checkOutTime = moment.unix(userTimeSheet[i]?.checkOutDateTime?.seconds).tz(userTimeSheet[i]?.apoointmentDetails?.calendarTimezone);


            if (checkOutTime?.isBefore(checkInTime)) {
              checkOutTime = checkOutTime?.add(1, "day");
            }

            const checkInOutTimeDiff = moment.duration(checkOutTime.diff(checkInTime));

            // const checkInOutTimeDiff = moment.duration(
            //   moment
            //     .unix(userTimeSheet[i]?.checkOutDateTime?.seconds)
            //     .diff(moment.unix(userTimeSheet[i]?.checkInDateTime?.seconds))
            // );

            const checkInStartTimeDiffHours = !checkInOutTimeDiff?.hours()
              ? 0
              : checkInOutTimeDiff?.hours();
            const checkInStartTimeDiffMinutes = !checkInOutTimeDiff?.minutes()
              ? 0
              : checkInOutTimeDiff?.minutes();

            hours = formatTimeDifference(
              checkInStartTimeDiffHours,
              checkInStartTimeDiffMinutes
            );

            // let checkInMiliseconds = parseFloat(
            //   checkInOutTimeDiff?._milliseconds
            // );
            // if (checkInMiliseconds < 0) {
            //   checkInMiliseconds = -1 * checkInMiliseconds;
            // }
            // allCheckInMiliseconds.push(checkInMiliseconds);
            let checkInMiliseconds = Math.abs(checkInOutTimeDiff.asMilliseconds());
            allCheckInMiliseconds.push(checkInMiliseconds);

            const taskArr = Object.keys(userTimeSheet[i].tasks);
            
            const shiftName = userTimeSheet[i]?.tasks[taskArr[0]]?.title;

            const popupItem = {
              location: userTimeSheet[i].location,
              shiftend_location: userTimeSheet[i].shiftend_location,
              shiftName: shiftName,
              In: checkInTime?.format("hh:mm a"),
              Out: checkOutTime?.isValid() ? checkOutTime?.format("hh:mm a") : "Not Available",
              // In: checkInTime,
              // Out:
              //   checkOutTime === "Invalid date"
              //     ? "Not Available"
              //     : checkOutTime,
            };

            // Extracting appointment date
            const appointmentDate = moment
              .tz(userTimeSheet[i]["appointmentDateTime"], "America/New_York")
              .format("YYYY-MM-DD");
            if (popupData[appointmentDate]) {
              popupData[appointmentDate].push(popupItem);
            } else {
              popupData[appointmentDate] = [popupItem];
            }

            if (
              resItem[
              moment(userTimeSheet[i]["appointmentDate"]).format("YYYY-MM-DD")
              ]
            ) {
              
              resItem[
                moment(userTimeSheet[i]["appointmentDate"]).format("YYYY-MM-DD")
              ] += parseFloat(hours);

              resItem["total"] += parseFloat(hours);
            } else {
              resItem[
                moment(userTimeSheet[i]["appointmentDate"]).format("YYYY-MM-DD")
              ] = parseFloat(hours);
              if (resItem["total"]) {
                resItem["total"] += parseFloat(hours);
              } else {
                resItem["total"] = parseFloat(hours);
              }

              dateArr.push(
                moment(userTimeSheet[i]["appointmentDate"]).format("YYYY-MM-DD")
              );
            }
          }
          for (let key in dateArr) {
            resItem[dateArr[key]] = resItem[dateArr[key]];
          }

          resItem["name"] = `${resItem.firstName} ${resItem.lastName}`;
          resItem["popupData"] = popupData;

          return resItem;
        });

        setEmpData(finaleData);
        setEmpFilterData(finaleData);
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getReportListData = async (startDt, endDt) => {
    const param = {
      startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
      endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`
    };
    
    setIsLoading(true);
    getTimesheetListReportOld(
      param,
      companyId,
      (result) => {
        const data = result;
        setIsLoading(false);
        const empIds = [];
        for (let i = 0; i < data?.length; i++) {
          if (empIds.indexOf(data?.[i].userId) === -1) {
            empIds.push(data?.[i].userId);
          }
        }
        mapWidhtUserList(empIds, data);
      },
      (err) => {
        setIsLoading(false);
        console.log("err>>", err);
      }
    );
  };

  const tableRightComponent = () => {
    return (
      <div className="d-flex w320 editEmp issueAlign ph-8">
        <div className="mr-24 d-flex flex-center">
          {" "}
          <FilterAltIcon className="mb-7 mt-12 issueicon" /> <span> Filters </span>{" "}
        </div>
        {data?.length > 0 && (
        <div className="reportsMargin mb-7 mt-12 issueicon timeWidth">
          <SingleSelect
            value={payPeriod}
            className={`field ${styles.wdate}`}
            name={"payPeriod"}
            label={"Pay Period"}
            onChange={(e) => onChangePayPeriod(e)}
            options={getPayPeriodDropDownOptions()}
          />
        </div>
        )}
        <div className="reportsMargin mb-7 mt-12">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="Start Date"
              className="customDate customDatePicker dark:[&_.MuiInputBase-input]:text-white dark:[&_.MuiInputLabel-root]:text-white"
              value={startDate}
              onChange={(newValue) => {
                setStartDate(newValue);
                // if (newValue) {
                //   setEndDate(moment());
                // } else {
                //   setEndDate(null);
                // }
                setPayPeriod("None");
              }}
              maxDate={moment()}
              views={["year", "month", "day"]}
              inputFormat="YYYY-MM-DD"
            />
          </LocalizationProvider>
        </div>
        <div className="reportsMargin mb-7 mt-12">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="End Date"
              className="customDate customDatePicker dark:[&_.MuiInputBase-input]:text-white dark:[&_.MuiInputLabel-root]:text-white"
              value={endDate}
              onChange={(newValue) => {
                setEndDate(newValue);
                // if (!newValue) {
                //   setStartDate(null);
                // }
                setPayPeriod("None");
              }}
              maxDate={moment()}
              views={["year", "month", "day"]}
              inputFormat="YYYY-MM-DD"
            />
          </LocalizationProvider>
        </div>
        <div className="reportsMargin mb-7 mt-12">
          <TextField
            name="search"
            value={empName}
            fullWidth={true}
            size="small"
            label={"Employee"}
            variant="outlined"
            className={`field ${styles.wdate2} dark:[&_.MuiInputBase-input]:text-white dark:[&_.MuiInputLabel-root]:text-white`}
            type={"text"}
            inputProps={{
              className: "p-10 ",
            }}
            onChange={handleEmpNameChange}
          />
        </div>
      </div>
    );
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem?.id) {
      case "name":
        return <div>{rcellItem[hcellItem?.id]}</div>;
      case "action":
        if (isMobile || isLandscape) {
          if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"TimeSheetReport"}
              />
            );
          } else {
            return null;
          }
        } else {
          if (
            rowindex !== 0 &&
            empFilterData[rowindex - 1].userId !== rcellItem.userId
          ) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={() => handleEmailIconClick(rcellItem)}
                name={"TimeSheetReport"}
              />
            );
          } else if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={() => handleEmailIconClick(rcellItem)}
                name={"TimeSheetReport"}
              />
            );
          } else {
            return "";
          }
        }
      default:
        if (!rcellItem[hcellItem?.id]) {
          return "-";
        } else {
          return (
            <CustomTooltip
              listData={rcellItem?.popupData?.[hcellItem.id]}
              title={rcellItem[hcellItem?.id]}
            />
          );
        }
    }
  };

  return (
    <>
      <Container className=" dark:bg-[#1A1F2C] dark:min-h-screen">
        <PageTitle
          pageTitle="TimeSheet Reports"
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Reports" },
            { label: "Employee Reports", to: "/reports/Employeereport" },
          ]}
          BreadCrumbCurrentPageTitle={"TimeSheet Reports"}
          showLastSeen={true}
        />

        <div className={`themeTableContainer mh-20 dark:bg-[#1A1F2C] dark:[&_table]:bg-[#1A1F2C] dark:[&_th]:bg-gray-800 dark:[&_td]:bg-[#1A1F2C] dark:[&_tr]:bg-[#1A1F2C]`}>
          {!detailedView && (
            <TableToolbar rightComponent={tableRightComponent()} />
          )}
          <div className={`themeTableContainer`}>
            <ResponsiveTable
              rows={empFilterData}
              getColumns={getColumns}
              hidePagination={true}
              isLoading={isLoading}
              renderRowCell={renderRowCell}
              detailedView={detailedView}
              setDetailedView={setDetailedView}
              fileName={"TimeSheet Report"}
              onClickPdf={handlePdfClick}
              onClickExcel={handleExcelClick}
              onClickCsv={handleCSvClick}
              clientsListCSV={clientsListCSV}
              onClickEmail={handelEmailClicks}
              payPeriod={payPeriod}
              getPayPeriodDropDownOptions={getPayPeriodDropDownOptions()}
            />
          </div>
        </div>
        {!detailedView && (
          <div className={`${styles.report} dark:bg-[#1A1F2C]`}>
            <div className={styles.download1}>
              <EmailRoundedIcon />
              <div>
                <Link
                  to={empData.length !== 0 && "/emailreports"}
                  rel="noopener"
                >
                  <Button
                    className={styles.actions}
                    disabled={empData.length === 0}
                    onClick={() => {
                      handelEmailFullReport();
                    }}
                  >
                    Full Report
                  </Button>
                </Link>
              </div>
            </div>
            <div className={styles.download1}>
              <PictureAsPdfIcon />
              <div>
                <Button
                  className={styles.actions}
                  disabled={empData.length === 0}
                  onClick={() => {
                    downloadForFullPDF();
                  }}
                >
                  Download Full Report
                </Button>
              </div>
            </div>
          </div>
        )}
      </Container>
    </>
  );
}

export default TimeSheet;
